// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".divider[data-v-2d09fb1d]{margin-bottom:25px;margin-top:22px}.content[data-v-2d09fb1d]{padding-bottom:100px}", ""]);
// Exports
module.exports = exports;
